<template>
    <div v-if="user">
        <div class="box-shadow mb-36">
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <div class="input-box mb-36">
                        <label class="color-text-label">Лицо*</label>
                        <multiselect v-model="postData.type"
                                     :options="type_options"
                                     selectedLabel=""
                                     selectLabel=""
                                     placeholder=""
                                     deselectLabel=""
                                     :allowEmpty="false"
                                     :searchable="false">
                        </multiselect>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="mb-36 input-box">
                        <label for="card_fio" class="color-text-label" :class="{'error-form': $v.postData.fio.$error}">
                            <span v-if="postData.type === 'Физическое лицо'">ФИО*</span>
                            <span v-else>Наименование*</span>
                        </label>
                        <input id="card_fio" type="text"
                               @input="delayTouch($v.postData.fio)"
                               :disabled="isFilled('fio')"
                               v-model.trim="postData.fio">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.fio.$error && !$v.postData.fio.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <!--  Юр. лицо -->
                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Юридическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_full_name" class="color-text-label" :class="{'error-form': $v.postData.full_name.$error}">Полное наименование*</label>
                        <input id="card_full_name" type="text"
                               @input="delayTouch($v.postData.full_name)"
                               :disabled="isFilled('full_name')"
                               v-model.trim="postData.full_name">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.full_name.$error && !$v.postData.full_name.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <!--  Юр. лицо -->
<!--                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Юридическое лицо'">-->
<!--                    <div class="mb-36 input-box">-->
<!--                        <label for="card_contract_date" class="color-text-label" :class="{'error-form': $v.postData.contract_date.$error}">Дата текущего договора*</label>-->
<!--                        <input id="card_contract_date" type="text"-->
<!--                               v-mask="'##.##.####'"-->
<!--                               placeholder="##.##.####"-->
<!--                               @input="delayTouch($v.postData.contract_date)"-->
<!--                               v-model.trim="postData.contract_date">-->
<!--                        <div class="error-box">-->
<!--                            <h6 class="pt-1 mb-0 error-form" v-if="$v.postData.contract_date.$error && !$v.postData.contract_date.required">Поле обязательно для заполнения</h6>-->
<!--                            <h6 class="pt-1 mb-0 error-form" v-if="$v.postData.contract_date.$error && !$v.postData.contract_date.minLength && $v.postData.contract_date.required">Неверный формат</h6>-->
<!--                            <h6 class="pt-1 mb-0 error-form" v-if="$v.postData.contract_date.$error && $v.postData.contract_date.minLength && !$v.postData.contract_date.date">Неверный формат</h6>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="col-sm-6 col-lg-4">
                    <div class="mb-36 input-box">
                        <label for="card_phone" class="color-text-label" :class="{'error-form': $v.postData.phone.$error}">
                            <span v-if="postData.type === 'Физическое лицо'">Телефон*</span>
                            <span v-else>Телефон (лица, использ. оборудование)*</span>
                        </label>
                        <input id="card_phone" type="text" @input="delayTouch($v.postData.phone)" v-model.trim="postData.phone" :disabled="isFilled('phone')">
                               <!--placeholder="+375"
                               v-mask="'+375#########'"
                               @input="delayTouch($v.postData.phone)"
                               v-model.trim="postData.phone">-->
                        <div class="error-box">
                            <dic class="h6 pt-1 error-form" v-if="$v.postData.phone.$error && !$v.postData.phone.required">Поле обязательно для заполнения</dic>
                            <dic class="h6 pt-1 error-form" v-if="$v.postData.phone.$error && $v.postData.phone.required && !$v.postData.phone.minLength">Неверный формат</dic>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="mb-36 input-box">
                        <label for="card_phone_2" class="color-text-label">
                            <span v-if="postData.type === 'Физическое лицо'">Телефон близкого родственника</span>
                            <span v-else>Телефон (бухгалтерия)</span>
                        </label>
                        <input id="card_phone_2" type="text" :disabled="isFilled('phone_2')" v-model="postData.phone_2">
                               <!--placeholder="+375"
                               v-mask="'+375#########'"
                               v-model="postData.phone_2"> -->
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_home_phone" class="color-text-label">Домашний телефон</label>
                        <input id="card_home_phone" type="text" :disabled="isFilled('home_phone')"
                               v-model="postData.home_phone">
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box" v-if="postData.type === 'Физическое лицо'">
                        <label for="card_email" class="color-text-label" :class="{'error-form': $v.postData.email.$error}">E-mail*</label>
                        <input id="card_email" type="email"
                               :disabled="isFilled('email')"
                               @input="delayTouch($v.postData.email)"
                               v-model.trim="postData.email">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.email.$error && !$v.postData.email.required">Поле обязательно для заполнения</div>
                            <div class="h6 pt-1 error-form" v-if="$v.postData.email.$error && $v.postData.email.required && !$v.postData.email.email">Неверный формат</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box" >
                        <label for="card_date_birth" class="color-text-label" :class="{'error-form': $v.postData.date_birth.$error}">Дата рождения*</label>
                        <input id="card_date_birth" type="text"
                               v-mask="'##.##.####'"
                               placeholder="##.##.####"
                               :disabled="isFilled('date_birth')"
                               @input="delayTouch($v.postData.date_birth)"
                               v-model.trim="postData.date_birth">
                        <div class="error-box">
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_birth.$error && !$v.postData.date_birth.required">Поле обязательно для заполнения</div>
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_birth.$error && !$v.postData.date_birth.minLength && $v.postData.date_birth.required">Неверный формат</div>
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_birth.$error && $v.postData.date_birth.minLength && !$v.postData.date_birth.date">Неверный формат</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_series_number_passport" class="color-text-label" :class="{'error-form': $v.postData.series_number_passport.$error}">Серия и номер паспорта*</label>
                        <input id="card_series_number_passport" type="text"
                               @input="delayTouch($v.postData.series_number_passport)"
                               :disabled="isFilled('series_number_passport')"
                               v-model.trim="postData.series_number_passport">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.series_number_passport.$error && !$v.postData.series_number_passport.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_id_number" class="color-text-label" :class="{'error-form': $v.postData.id_number.$error}">Идентификационный номер*</label>
                        <input id="card_id_number" type="text"
                               @input="delayTouch($v.postData.id_number)"
                               :disabled="isFilled('id_number')"
                               v-model.trim="postData.id_number">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.id_number.$error && !$v.postData.id_number.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_given" class="color-text-label" :class="{'error-form': $v.postData.given.$error}">Кем выдан паспорт*</label>
                        <input id="card_given" type="text"
                               @input="delayTouch($v.postData.given)"
                               :disabled="isFilled('given')"
                               v-model.trim="postData.given">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.given.$error && !$v.postData.given.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_date_given" class="color-text-label" :class="{'error-form': $v.postData.date_given.$error}">Дата выдачи паспорта*</label>
                        <input id="card_date_given" type="text"
                               v-mask="'##.##.####'"
                               placeholder="##.##.####"
                               :disabled="isFilled('date_given')"
                               @input="delayTouch($v.postData.date_given)"
                               v-model.trim="postData.date_given">
                        <div class="error-box">
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_given.$error && !$v.postData.date_given.required">Поле обязательно для заполнения</div>
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_given.$error && !$v.postData.date_given.minLength && $v.postData.date_given.required">Неверный формат</div>
                            <div class="h6 pt-1 mb-0 error-form" v-if="$v.postData.date_given.$error && $v.postData.date_given.minLength && !$v.postData.date_given.date">Неверный формат</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_actual_address" class="color-text-label" :class="{'error-form': $v.postData.actual_address.$error}">Адрес фактического проживания*</label>
                        <input id="card_actual_address" type="text"
                               @input="delayTouch($v.postData.actual_address)"
                               :disabled="isFilled('actual_address')"
                               v-model.trim="postData.actual_address">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.actual_address.$error && !$v.postData.actual_address.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_registration_address" class="color-text-label" :class="{'error-form': $v.postData.registration_address.$error}">Адрес прописки*</label>
                        <input id="card_registration_address" type="text"
                               :disabled="isFilled('registration_address')"
                               @input="delayTouch($v.postData.registration_address)"
                               v-model.trim="postData.registration_address">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.registration_address.$error && !$v.postData.registration_address.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_registration_address" class="color-text-label" :class="{'error-form': $v.postData.gender.$error}">Пол*</label>
                        <multiselect @input="delayTouch($v.postData.gender)"
                                     v-model.trim="postData.gender"
                                     :options="gender_options"
                                     selectedLabel=""
                                     selectLabel=""
                                     placeholder=""
                                     deselectLabel=""
                                     :allowEmpty="false"
                                     :searchable="false">
                        </multiselect>
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.gender.$error && !$v.postData.gender.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_place_work" class="color-text-label" :class="{'error-form': $v.postData.place_work.$error}">Место работы*</label>
                        <input id="card_place_work" type="text"
                               @input="delayTouch($v.postData.place_work)"
                               :disabled="isFilled('place_work')"
                               v-model.trim="postData.place_work">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.place_work.$error && !$v.postData.place_work.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_profession" class="color-text-label" :class="{'error-form': $v.postData.profession.$error}">Профессия*</label>
                        <input id="card_profession" type="text"
                               @input="delayTouch($v.postData.profession)"
                               :disabled="isFilled('profession')"
                               v-model.trim="postData.profession">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.profession.$error && !$v.postData.profession.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="mb-36 input-box">
                        <label for="card_work_phone" class="color-text-label">Рабочий телефон</label>
                        <input id="card_work_phone" type="text"
                               :disabled="isFilled('work_phone')"
                               v-model="postData.work_phone">
                    </div>
                </div>


                <!--  Юр. лицо -->
                <div class="col-12" v-if="postData.type === 'Юридическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_requisites" class="color-text-label" :class="{'error-form': $v.postData.requisites.$error}">Реквизиты*</label>
                        <input id="card_requisites" type="text" class="max-w-full"
                               @input="delayTouch($v.postData.requisites)"
                               :disabled="isFilled('requisites')"
                               v-model.trim="postData.requisites">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.requisites.$error && !$v.postData.requisites.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <!--  Юр. лицо -->
                <div class="col-12" v-if="postData.type === 'Юридическое лицо'">
                    <div class="mb-36 input-box w-100">
                        <label for="card_in_person" class="color-text-label" :class="{'error-form': $v.postData.in_person.$error}">В лице*</label>
                        <textarea id="card_in_person" type="text"
                               class="w-100 max-w-full"
                               @input="delayTouch($v.postData.in_person)"
                                  :disabled="isFilled('in_person')"
                                  v-model.trim="postData.in_person"></textarea>
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.in_person.$error && !$v.postData.in_person.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>


                <div class="col-sm-6 col-lg-4" v-if="postData.type === 'Физическое лицо'">
                    <div class="mb-36 input-box">
                        <label for="card_social_link" class="color-text-label" :class="{'error-form': $v.postData.social_link.$error}">Ссылка на соц. сети*</label>
                        <input id="card_social_link" type="text"
                               @input="delayTouch($v.postData.social_link)"
                               :disabled="isFilled('social_link')"
                               v-model.trim="postData.social_link">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.postData.social_link.$error && !$v.postData.social_link.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-12">
                    <div class="mb-32 checkbox" :class="{'error-form': $v.postData.register_confirm_agree.$error}">
                        <input id="register_confirm_agree" type="checkbox"
                               @input="delayTouch($v.postData.register_confirm_agree)"
                               v-model.trim="postData.register_confirm_agree">
                        <label for="register_confirm_agree">Я даю согласие на <router-link to="/rules/obrabotka-personalnykh-dannykh " class="text-underline">обработку персональных данных</router-link></label>
                    </div>
                </div>

            </div>
        </div>

        <div>
            <button type="button" class="button btn-large" @click="saveData()">Сохранить</button>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import order from '../../../../services/order';

    import {
        phoneRule,
        requiredRule,
        reqIfPerson,
        reqEmailIfPerson,
        reqDateIfPerson,
        reqIfOrganization,
        reqDateIfOrganization,
        checkbox
    } from '../../../../services/validation';
    const touchMap = new WeakMap();

    export default {
        components: { Multiselect },
        data() {
            return {
                postData: {
                    type: 'Физическое лицо',
                    fio: null,
                    phone: null,
                    phone_2: null,
                    work_phone: null,

                    home_phone: null,
                    email: null,
                    date_birth: null,
                    series_number_passport: null,
                    id_number: null,
                    given: null,
                    date_given: null,
                    actual_address: null,
                    registration_address: null,
                    gender: null,
                    place_work: null,
                    profession: null,
                    social_link: null,

                    full_name: null,
                    // contract_date: null,
                    requisites: null,
                    in_person: null,
                    register_confirm_agree: false
                },

                type_options: [ 'Физическое лицо', 'Юридическое лицо' ],
                gender_options: [ 'Мужской', 'Женский' ],
                filledMap: {},
                order: order
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        watch: {
            user() {
                this.init();
            }
        },

        mounted() {
            this.init();
        },

        methods: {
            init() {
                if(this.user) {
                    if(this.user.card) {
                        this.postData = this.user.card;
                        if(this.user.card.date_birth) this.postData.date_birth = this.getDate(this.postData.date_birth);
                        if(this.user.card.date_given) this.postData.date_given = this.getDate(this.postData.date_given);
                        // if(this.user.card.contract_date) this.postData.contract_date = this.getDate(this.postData.contract_date);
                        for (const key in this.postData) {
                            if (this.postData.hasOwnProperty(key) && this.postData[key] !== null && this.postData[key] !== '' && this.postData[key] !== '+375') {
                                this.filledMap[key] = this.postData[key];
                            }
                        }
                    }
                }
            },
            saveData() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    if(this.postData.type === 'Физическое лицо') {
                        this.postData.full_name = null;
                        // this.postData.contract_date = null;
                        this.postData.requisites = null;
                        this.postData.in_person = null;
                    }
                    if(this.postData.type === 'Юридическое лицо') {
                        this.postData.home_phone = null;
                        this.postData.email = null;
                        this.postData.date_birth = null;
                        this.postData.series_number_passport = null;
                        this.postData.id_number = null;
                        this.postData.given = null;
                        this.postData.date_given = null;
                        this.postData.actual_address = null;
                        this.postData.registration_address = null;
                        this.postData.gender = null;
                        this.postData.place_work = null;
                        this.postData.profession = null;
                        this.postData.social_link = null;
                    }

                    this.loading = true;
                    let url = '/api/create-update-card';
                    const options = {
                        headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                    };
                    axios.post(url, this.postData, options)
                        .then(response => {
                            if(response.status == 200) {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Готово!',
                                    html: `Данные успешно сохранены.`,
                                });
                                this.$store.dispatch('fetchUser');
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },

            getDate(date) {
                return this.order.echoDate(date)
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            },
            isFilled(fieldName){
                return this.filledMap.hasOwnProperty(fieldName)
            }
        },

        validations: {
            postData: {
                fio: requiredRule,
                phone: phoneRule,
                register_confirm_agree: checkbox,
                email: reqEmailIfPerson,
                date_birth: reqDateIfPerson,
                series_number_passport: reqIfPerson,
                id_number: reqIfPerson,
                given: reqIfPerson,
                date_given: reqDateIfPerson,
                actual_address: reqIfPerson,
                registration_address: reqIfPerson,
                gender: reqIfPerson,
                place_work: reqIfPerson,
                profession: reqIfPerson,
                social_link: reqIfPerson,

                full_name: reqIfOrganization,
                // contract_date: reqDateIfOrganization,
                requisites: reqIfOrganization,
                in_person: reqIfOrganization,
            }
        }
    }
</script>
